import enJson from "@/app/locales/english.json";
import chJson from "@/app/locales/chinese.json";

const t = (language: string, key: string, defaultValue?: string) => (language === "en-us" ? enJson as any : chJson as any)[key] || defaultValue || key

export const getMetaTitle= (language: string, pagename: string) => {
  let title_name = 'page_title_' + pagename;
  return t(language, title_name);
};

// export const getMetaIcon = (assetPrefix: string) => {
//   return [{ rel: "icon", url: `${assetPrefix}/favicon.ico` }, { rel: "apple-touch-icon", url: `${assetPrefix}/favicon.ico` }]
// };